import cryptoRandomString from 'crypto-random-string';

export default function uniqueString() {
	return cryptoRandomString({length: 32});
}
